import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class PenaltiesComponent extends Component
{
	@service store;
	@service errorManager;
	
	@tracked isAddingNew = false;
	
	@tracked newPenaltyBib = null;
	@tracked newPenaltyDescription = "";
	@tracked newPenaltyDescriptionLong = "";
	@tracked newPenaltyType = "Time";
	@tracked newPenaltyTime = "00:00:00";
	@tracked newPenaltyIsBonus = false;
	
	@action
	async saveNewPenalty(browserEvent)
	{
		browserEvent.preventDefault();
		
		let bib = this.newPenaltyBib;
		let time = this.newPenaltyTime;
		let type = this.newPenaltyType;
		let description = this.newPenaltyDescription;
		let isBonus = this.newPenaltyIsBonus;
		
		let entryForBib = null;
		const entries = await this.args.event.get('entries');

		for(const entry of entries)
		{
			if(entry.bib == bib)
				entryForBib = entry;
		}
			
		if(entryForBib == null)
		{
			this.errorManager.addError("Bib number not found in entries", { clearable: true, type: 'validation' });
			return;
		}

		const dateTime = dayjs(time,'HH:mm:ss.SSS');

		if(!dateTime.isValid())
		{
			this.errorManager.addError("Invalid time. Use HH:mm:ss.SSS format", { clearable: true, type: 'validation' });
			return;
		}
		
		if(description == "343.5")
			description = "343.5 Did not wear proper identification (bib, leg bib, transponder, GPS)";
		if(description == "325.4.2.10")
			description = "325.4.2.10 False Start in Sprint";
		if(description == "343.6")
			description = "343.6 Did not follow the marked course";
		if(description == "343.8")
			description = "343.8 Violation of the classical technique rules";
		if(description == "343.9")
			description = "343.9 Obstruction";
		if(description == "352.4.1")
			description = "352.4.1 Early Start Infraction";
		if(description == "344.1")
			description = "344.1 Not following special regulations of the Jury";
		if(description == "Other")
			description = this.newPenaltyDescriptionLong;
		
		const newPenaltyRecord = this.store.createRecord('PenaltyTimingRecord',
		{
			EventId: this.args.event,
			EntryId: entryForBib,
			time: dateTime.toDate(),
			description: description,
			type: type,
			isBonus: isBonus
		});

		try
		{
			await newPenaltyRecord.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newPenaltyRecord.rollbackAttributes();
			return;
		}

		this.isAddingNew = false;
		this.newPenaltyBib = null;
		this.newPenaltyDescription = "";
		this.newPenaltyDescriptionLong = "";
		this.newPenaltyType = "Time";
		this.newPenaltyTime = "00:00:00";
		this.newPenaltyIsBonus = false;
	}
	
	@action
	cancelNewPenalty()
	{
		this.isAddingNew = false;
		this.newPenaltyBib = null;
		this.newPenaltyDescription = "";
		this.newPenaltyDescriptionLong = "";
		this.newPenaltyType = "Time";
		this.newPenaltyTime = "00:00:00";
		this.newPenaltyIsBonus = false;
	}
	
	@action
	async deletePenalty(penalty)
	{
		penalty.deleteRecord();
		try
		{
			await penalty.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			penalty.rollbackAttributes();
		}
	}
	
	@action
	selectPenaltyType(event)
	{
		this.newPenaltyType = event.target.value;
	}
	
	@action
	selectDescription(event)
	{
		this.newPenaltyDescription = event.target.value;
	}
}  